import * as React from "react";
const Chaussures = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 408 1220" {...props}>
		<defs>
			<style>
				{".cls-1{fill:none;}.cls-2{stroke:#000;stroke-miterlimit:10;}"}
			</style>
		</defs>
		<title>{"chaussures all frames"}</title>
		<g id="cadre">
			<rect className="cls-1" width={408} height={1220} />
		</g>
		<g id="pantalon">
			<g id="frame_1" data-name="frame 1">
				<path
					className="cls-2"
					d="M1104.74,1557.62s.76,53.88,7.76,67.88h158s10-48-30-55-47-19-47-19-3-15-22-16S1104.74,1557.62,1104.74,1557.62Z"
					transform="translate(-878.5 -427.5)"
				/>
				<path
					className="cls-2"
					d="M926.5,1562.5l4-7s49,9,52,7,5,57,2,60-5,17-37,19-55-10-56-12c0-13-6-44,19-54A118,118,0,0,0,926.5,1562.5Z"
					transform="translate(-878.5 -427.5)"
				/>
			</g>
		</g>
	</svg>
);
export default Chaussures;
